import MeetingRoomInfoMessage from "../../Room/MeetingRoomInfoMessage";
import { Box, Button, Checkbox, FormControlLabel, Modal } from "@mui/material";
import { OutlookDeepLinkParam } from "../../../../system/types/meetingRoom/MeetingRoom";
import { useMeetingRoom } from "../../../../hooks/MeetingRoom/useMeetingRoom";
import { useCallback, useEffect, useState } from "react";
import { ReservationButton } from "../../Tabs/MeetingRoomTabsStyled";
import { Blue400 } from "../../../../styles/color";
import { useDeviceType } from "../../../../hooks/useDeviceType";

type MeetingRoomGuidePopupModalProps = {
  guidePopupInfo: {
    modalOpen: boolean;
    params: OutlookDeepLinkParam[];
  };
  handleOpenGuidePopup: (
    status: boolean,
    params: OutlookDeepLinkParam[]
  ) => void;
  handleOpenOutlookPopup: (params: OutlookDeepLinkParam[]) => void;
};
const MeetingRoomGuidePopupModal = ({
  guidePopupInfo,
  handleOpenGuidePopup,
  handleOpenOutlookPopup,
}: MeetingRoomGuidePopupModalProps) => {
  const [doNotShowChecked, setDoNotShowChecked] = useState(false);

  const { modalOpen, params } = guidePopupInfo;
  const { setHidePopupForWeek, removeHidePopupForWeek } = useMeetingRoom();

  const handleClickHideForWeek = useCallback(
    (value: boolean) => {
      setDoNotShowChecked(value);
      if (value) setHidePopupForWeek();
      else removeHidePopupForWeek();
    },
    [setHidePopupForWeek, removeHidePopupForWeek]
  );

  const handleClickReserveButton = useCallback(async () => {
    await handleOpenOutlookPopup(params);
    await handleOpenGuidePopup(false, []);
  }, [handleOpenOutlookPopup, handleOpenGuidePopup, params]);

  const deviceType = useDeviceType();

  useEffect(() => {
    if (modalOpen) setDoNotShowChecked(false);
  }, [modalOpen]);
  return (
    <Modal open={modalOpen} onClose={() => handleOpenGuidePopup(false, [])}>
      <Box
        sx={{
          position: "absolute" as const,
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          padding:
            deviceType === "pc"
              ? "24px 32px"
              : deviceType === "tablet"
              ? "20px 20px"
              : "12px 16px", // mobile,
          borderRadius: "8px",
          boxShadow: 24,
          minWidth: "360px",
          // maxWidth: "480px",
          outline: "none",
        }}
      >
        <MeetingRoomInfoMessage />
        <Box
          sx={{
            display: "flex",
            marginTop: "16px",
            justifyContent: "flex-end",
            gap: "16px",
            alignItems: "center",
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={doNotShowChecked}
                onChange={(e) => handleClickHideForWeek(e.target.checked)}
                sx={{
                  paddingRight: 0.5,
                  color: "rgba(0, 0, 0, 0.6)",
                  "&.Mui-checked": {
                    color: Blue400, // 원하는 체크된 색상
                  },
                }}
              />
            }
            label="일주일간 보지 않기"
            sx={{
              m: 0,
              "& .MuiFormControlLabel-label": {
                fontSize: "0.875rem", // 폰트 크기 수정
              },
            }}
          />
          <ReservationButton onClick={handleClickReserveButton}>
            예약하기
          </ReservationButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default MeetingRoomGuidePopupModal;
